import React from "react";
import { connect } from "react-redux";
import { increaseCounter, decreaseCounter } from "app/redux/actions";
import { ClipLoader } from "react-spinners";
import contextProvider from "app/contextProvider";
import { LinkContainer } from "react-router-bootstrap";
import { withRouter, NavLink } from "react-router-dom";
import { Input, Badge } from "reactstrap";
import Responsive from "react-responsive-decorator";
//import moment from 'moment/min/moment-with-locales';
import moment from "moment";
import "moment/locale/en-gb";
import "moment/locale/it";
import "moment/locale/nl";
import "moment/locale/es";
import "moment/locale/fr";
import "moment/locale/pt";
import ProbeMeasureExplorerAggregate from "./components/Pages/ProbeMeasureExplorerAggregate";
import _ReactOApp from "app/_L0_components/_ReactOApp";
import { _LoadingWrapper } from "app/_L0_components/Widgets/_LoadingKit";
import AggregateMeasuresFlat from "./components/Pages/AggregateMeasuresFlat";

//import ApiTester from 'app/components/Pages/ApiTester';

import Login from "app/components/Pages/Login";
//import ConfMockup from 'app/components/Pages/ConfMockup';
import Dashboard from "app/components/Pages/Dashboard";
import Account from "app/components/Pages/Account";
//import Test from 'app/components/Pages/Test';
import ProbeSetup from "app/components/Pages/ProbeSetup";
import ProbeConfig from "app/components/Pages/ProbeConfig";
// import ProbeUserTests from "app/components/Pages/ProbeUserTests";
import ProbeMeasures from "app/components/Pages/ProbeMeasures";
import ProbeMeasureExplorer from "app/components/Pages/ProbeMeasureExplorer";
import ProbeMeasureResults from "app/components/Pages/ProbeMeasureResults";
import ApCoverage from "app/components/Pages/ApCoverage";
import SearchResults from "app/components/Pages/SearchResults";
import ProbeSetupGeneral from "app/components/Subroutes/ProbeSetup/General";
import Teams from "./components/Subroutes/ProbeSetup/Teams";
import ProbeSetupWifi from "app/components/Subroutes/ProbeSetup/Wifi";
import ProbeSetupEthernet from "app/components/Subroutes/ProbeSetup/Ethernet";
import ProbeSetupUsers from "app/components/Subroutes/ProbeSetup/Users";
import ProbeSetupUsb from "app/components/Subroutes/ProbeSetup/Usb";
import ProbeSetupSignalTHold from "app/components/Subroutes/ProbeSetup/SignalTHold";
import ProbeSetupNotifications from "app/components/Subroutes/ProbeSetup/Notifications";
import ProbeSetupSync from "app/components/Subroutes/ProbeSetup/Sync";
import ProbeAbout from "app/components/Subroutes/ProbeSetup/About";
import ProbConf from "app/components/Pages/ProbConf";
import SdConf2 from "app/components/Pages/SdConf2";
import Dev from "app/components/Pages/Dev";
import ServicePage from "app/components/Pages/ServicePage";
import UserManagement from "./components/Pages/UserManagement";
import GroupList from "./components/Pages/GroupList";
import Logcat from "app/components/Pages/Logcat.jsx";
import StepViewer from "app/components/Pages/StepViewer.jsx";
import FontDemo from "app/components/Pages/FontDemo";
import ReactOButton from "app/_L1_components/Elements/ReactOButton";
import ReactOCollapse from "app/_L1_components/Elements/ReactOCollapse";
import ReactOModal from "app/_L1_components/Elements/ReactOModal";
import SpectroChart from "app/components/Elements/SpectroChart";
import NotificationsSettings from "./components/Pages/NotificationsSettings";

moment.locale([
  window.navigator.userLanguage || window.navigator.language,
  "en",
]);

//const $ = window.jQuery
class App extends _ReactOApp {
  constructor(props) {
    var initState = {
      loading: true,
      accountData: {},
    };
    super(props, initState);

    // this.globalTime = 0
    this.cachedState = null;
    this._autorefresh = null;
    this.apiStoreService.setAPIStore({
      login: {
        authenticated: false,
        useCluster: "no",
        url: "/login",
        method: "POST",
      },
      post_login: {
        authenticated: false,
        url: "/postLogin",
        method: "POST",
      },
      test1: {
        authenticated: true,
        url: "/test1",
        method: "PUT",
      },
      test2: {
        authenticated: true,
        url: "/test2",
        method: "POST",
      },
      change_pass: {
        authenticated: true,
        useCluster: "no",
        url: "/account/chpass",
        method: "PUT",
      },
      management: {
        authenticated: true,
        url: "/probes/___-probeuid-___/setup/management",
        method: "PUT",
      },
      logout: {
        authenticated: true,
        useCluster: "no",
        url: "/logout",
        method: "GET",
      },
      rotate_img: {
        authenticated: true,
        method: "GET",
        url: "/probes/___-probeuid-___/rotatephoto/___-image-___",
      },
      platform: {
        authenticated: false,
        useCluster: "no",
        url: "/web/platform",
        method: "GET",
      },
      dashboard: {
        authenticated: true,
        url: "/dashboard",
        method: "GET",
      },
      probes: {
        authenticated: true,
        url: "/probes",
        method: "GET",
      },
      dashboard_essids_view: {
        authenticated: true,
        url: "/web/dashboard/essidsview",
        method: "GET",
      },
      dashboard_diag: {
        authenticated: true,
        url: "/web/dashboard/diag",
        method: "GET",
      },
      probe: {
        authenticated: true,
        url: "/probes/___-probeuid-___",
        method: "GET",
      },
      probe_info: {
        authenticated: true,
        url: "/probes/___-probeuid-___/info",
        method: "GET",
      },
      probe_spectro: {
        authenticated: true,
        url: "/probes/___-probeuid-___/spectro",
        method: "POST",
      },
      overlaps: {
        authenticated: true,
        url: "/probes/___-probeuid-___/overlaps",
        method: "POST",
      },
      probes_location: {
        authenticated: true,
        url: "/probes/location2",
        method: "GET",
      },
      probe_about: {
        authenticated: true,
        url: "/probes/___-probeuid-___/about",
        method: "GET",
      },
      probe_capabilities: {
        authenticated: true,
        url: "/probes/___-probeuid-___/capabilities",
        method: "GET",
      },
      probe_cst_sync_status: {
        authenticated: true,
        url: "/probes/___-probeuid-___/confs/syncstatus",
        method: "GET",
      },
      meet_reservation_status: {
        authenticated: true,
        url: "/probes/___-probeuid-___/getReservationData",
        method: "GET",
      },

      meet_reservation_set: {
        authenticated: true,
        url: "/probes/___-probeuid-___/setReservationData/___-minutes-___",
        method: "GET",
      },
      csv_script: {
        authenticated: true,
        url: "/probes/___-probeuid-___/runCVEScript",
        method: "POST",
      },

      /*
       *	Web views
       */
      get_aggregate: {
        authenticated: true,
        url: "/web/mlist/___-probeuid-___/aggregate",
        method: "POST",
      },
      get_aggregate_flat: {
        authenticated: true,
        url: "/web/mlist/aggregate",
        method: "POST",
      },
      get_aggregate_graph: {
        authenticated: true,
        url: "/web/mgraph/aggregate",
        method: "POST",
      },
      get_measures_list: {
        authenticated: true,
        url: "/web/mlist/___-probeuid-___/___-measureid-___",
        method: "POST",
      },
      get_archived_measures_list: {
        authenticated: true,
        url: "/web/archived_mlist/___-probeuid-___/___-measureid-___",
        method: "POST",
      },
      get_paused_measures_list: {
        authenticated: true,
        url: "/web/paused_mlist/___-probeuid-___/___-measureid-___",
        method: "POST",
      },
      get_measure_graph: {
        authenticated: true,
        url: "/web/mgraph/___-probeuid-___/___-measureid-___/___-bssid-___",
        method: "POST",
      },
      get_error_graph: {
        authenticated: true,
        url: "/web/merrorgraph/___-probeuid-___/___-measureid-___/___-bssid-___",
        method: "POST",
      },
      get_error_graph_aggregate: {
        authenticated: true,
        url: "/web/merrorAggregateGraph/___-probeuid-___/___-measureid-___/___-bssid-___",
        method: "POST",
      },
      get_step_graph: {
        authenticated: true,
        url: "/web/steptiming/___-probeuid-___/___-measureid-___/___-bssid-___",
        method: "POST",
      },
      get_step_graph_aggregate: {
        authenticated: true,
        url: "/web/steptimingAggregate/___-bssid-___",
        method: "POST",
      },
      get_step_graph_error: {
        authenticated: true,
        url: "/web/steptimingerror/___-probeuid-___/___-measureid-___/___-bssid-___",
        method: "POST",
      },
      get_step_graph_error_aggregate: {
        authenticated: true,
        url: "/web/steptimingAggregateError/___-bssid-___",
        method: "POST",
      },
      get_measure_graph_popup: {
        authenticated: true,
        url: "/web/mgraphpopup/___-probeuid-___/___-measureid-___/___-bssid-___/___-ts-___",
        method: "POST",
      },
      get_measure_graph_popup_aggregate: {
        authenticated: true,
        url: "/web/mgraphpopup/aggregate/___-ts-___",
        method: "POST",
      },
      get_error_graph_popup: {
        authenticated: true,
        url: "/web/merrorpopup/___-probeuid-___/___-measureid-___/___-bssid-___/___-ts-___",
        method: "POST",
      },
      get_measure_results: {
        authenticated: true,
        url: "/web/mresults/___-probeuid-___/___-measureid-___/___-bssid-___/___-ts-___",
        method: "POST",
      },

      /*
       *	Probe synchronization
       */
      get_probe_macro_sync: {
        authenticated: true,
        url: "/probes/___-probeuid-___/macros/sync",
        method: "GET",
      },
      set_probe_macro_sync: {
        authenticated: true,
        url: "/probes/___-probeuid-___/macros/sync",
        method: "PUT",
      },

      /*
       *	Settings
       */
      get_probe_setup: {
        authenticated: true,
        url: "/probes/___-probeuid-___/setup",
        method: "GET",
      },
      get_probe_setup_with_filter: {
        authenticated: true,
        url: "/probes/___-probeuid-___/setup/___-entry_path-___",
        method: "GET",
      },
      set_probe_setup: {
        authenticated: true,
        url: "/probes/___-probeuid-___/setup",
        method: "PUT",
      },
      set_probe_setup_with_filter: {
        authenticated: true,
        url: "/probes/___-probeuid-___/setup/___-entry_path-___",
        method: "PUT",
      },
      set_multi_setup: {
        authenticated: true,
        url: "/probes/___-probeuid-___/multi_setup",
        method: "PUT",
      },
      get_probe_photos: {
        authenticated: true,
        url: "/probes/___-probeuid-___/photos",
        method: "GET",
      },
      upload_probe_photos: {
        authenticated: true,
        url: "/probes/___-probeuid-___/photos",
        method: "POST",
      },
      delete_probe_photos: {
        authenticated: true,
        url: "/probes/___-probeuid-___/photos/___-photoid-___",
        method: "DELETE",
      },
      set_favourite_probe_photos: {
        authenticated: true,
        url: "/probes/___-probeuid-___/photos/___-photoid-___",
        method: "PUT",
      },
      // 'set_sd_conf': {
      // 	authenticated: true,
      // 	url: '/probes/___-probeuid-___/confs',
      // 	method: 'PUT'
      // },

      sd_confs: {
        authenticated: true,
        url: "/probes/___-probeuid-___/confs",
        method: "PUT",
      },
      apcoverage: {
        authenticated: true,
        url: "/probes/___-probeid-___/apcoverage",
        method: "PUT",
      },
      /*
       *	Account
       */
      get_account_integrations: {
        authenticated: true,
        url: "/accounts/integrations",
        method: "GET",
      },
      set_account_integrations: {
        authenticated: true,
        url: "/accounts/integrations",
        method: "PUT",
      },

      // USER TEST

      // get_UDT: {
      //   authenticated: true,
      //   url: "/usertests",
      //   method: "GET",
      // },
      // create_UDT: {
      //   authenticated: true,
      //   url: "/usertests/___-testid-___",
      //   method: "POST",
      // },
      // save_UDT: {
      //   authenticated: true,
      //   url: "/usertests/___-testid-___",
      //   method: "PUT",
      // },
      // delete_UDT: {
      //   authenticated: true,
      //   url: "/usertests/___-testid-___",
      //   method: "DELETE",
      // },
      /*
       *	Measures conf
       */
      get_probe_confs: {
        authenticated: true,
        url: "/probes/___-probeuid-___/confs",
        method: "GET",
      },
      get_probe_confs_with_filter: {
        authenticated: true,
        url: "/probes/___-probeuid-___/confs/___-entry_path-___",
        method: "GET",
      },
      set_probe_confs: {
        authenticated: true,
        url: "/probes/___-probeuid-___/confss",
        method: "PUT",
      },
      set_probe_confs_with_filter: {
        authenticated: true,
        url: "/probes/___-probeuid-___/confs/___-measureid-___",
        method: "PUT",
      },
      create_probe_conf: {
        authenticated: true,
        url: "/probes/___-probeuid-___/confs",
        method: "POST",
      },
      pause_probe_conf: {
        authenticated: true,
        url: "/probes/___-probeuid-___/confs/___-measureid-___/pause",
        method: "PUT",
      },
      resume_probe_conf: {
        authenticated: true,
        url: "/probes/___-probeuid-___/confs/___-measureid-___/resume",
        method: "PUT",
      },
      archive_probe_conf: {
        authenticated: true,
        url: "/probes/___-probeuid-___/confs/___-measureid-___/archive",
        method: "PUT",
      },
      delete_probe_conf: {
        authenticated: true,
        url: "/probes/___-probeuid-___/confs/___-measureid-___/___-status-___",
        method: "DELETE",
      },

      /*
       *	Login management
       */
      get_user: {
        authenticated: true,
        url: "/extlogin",
        method: "GET",
        useCluster: "no",
      },
      get_group_list: {
        authenticated: true,
        url: "/extlogin/getList",
        method: "GET",
        useCluster: "no",
      },
      get_group_list_filter: {
        authenticated: true,
        url: "/extlogin/getList/___-group-___",
        method: "GET",
        useCluster: "no",
      },
      create_user: {
        authenticated: true,
        url: "/extlogin",
        method: "POST",
        useCluster: "no",
      },
      edit_user: {
        authenticated: true,
        url: "/extlogin",
        method: "PUT",
        useCluster: "no",
      },
      delete_user: {
        authenticated: true,
        url: "/extlogin/___-id_als-___",
        method: "DELETE",
        useCluster: "no",
      },

      /*
       *	Probe users
       */
      get_probe_users: {
        authenticated: true,
        url: "/probes/___-probeuid-___/users",
        method: "GET",
      },
      set_probe_users: {
        authenticated: true,
        url: "/probes/___-probeuid-___/users",
        method: "PUT",
      },
      set_probe_users_with_filter: {
        authenticated: true,
        url: "/probes/___-probeuid-___/users/___-userid-___",
        method: "PUT",
      },
      create_probe_user: {
        authenticated: true,
        url: "/probes/___-probeuid-___/users",
        method: "POST",
      },
      delete_probe_user: {
        authenticated: true,
        url: "/probes/___-probeuid-___/users/___-userid-___",
        method: "DELETE",
      },
      load_suggestions: {
        authenticated: true,
        url: "/web/dashboard/sdconf",
        method: "GET",
      },
      load_suggestions2: {
        authenticated: true,
        url: "/web/dashboard/sdconf2",
        method: "GET",
      },
      sdlog: {
        authenticated: true,
        url: "/web/dashboard/sdlog",
        method: "PUT",
      },

      /*
       *	Altro
       */
      get_probe_network_scan: {
        authenticated: true,
        url: "/probes/___-probeuid-___/netscan",
        method: "GET",
      },
      get_probe_tests: {
        authenticated: true,
        url: "/probes/___-probeuid-___/tests",
        method: "GET",
      },
      download_pcap: {
        authenticated: true,
        url: "/utils/dlpcap/___-probeuid-___/___-measureid-___/___-bssid-___/___-pcap-___",
        binary: true,
        method: "GET",
      },
      download_har: {
        authenticated: true,
        url: "/utils/dlhar/___-probeuid-___/___-measureid-___/___-bssid-___/___-har-___/___-viewer-___",
        binary: true,
        method: "GET",
      },
      download_screenshot: {
        authenticated: true,
        url: "/utils/dlscreenshot/___-probeuid-___/___-measureid-___/___-bssid-___/___-screenshot-___",
        binary: true,
        method: "GET",
      },
      download_csv: {
        authenticated: true,
        url: "/utils/dlcsv/___-probeuid-___/___-measureid-___/___-bssid-___/___-csv-___",
        binary: true,
        method: "GET",
      },
      get_measure_note: {
        authenticated: true,
        url: "/probes/___-probeuid-___/notes/___-measureid-___",
        method: "GET",
      },
      get_measure_note_at: {
        authenticated: true,
        url: "/probes/___-probeuid-___/notes/___-measureid-___/___-ts-___",
        method: "GET",
      },
      create_measure_note: {
        authenticated: true,
        url: "/probes/___-probeuid-___/notes/___-measureid-___",
        method: "POST",
      },
      set_measure_note: {
        authenticated: true,
        url: "/probes/___-probeuid-___/notes/___-measureid-___/___-noteid-___",
        method: "PUT",
      },
      delete_measure_note: {
        authenticated: true,
        url: "/probes/___-probeuid-___/notes/___-measureid-___/___-noteid-___",
        method: "DELETE",
      },
      get_measure_certificates: {
        authenticated: true,
        url: "/utils/meacerts/___-probeuid-___/___-measureid-___",
        method: "GET",
      },
      parse_measure_certificate: {
        authenticated: true,
        url: "/utils/meacertparse",
        method: "POST",
      },
      parse_measure_pkey: {
        authenticated: true,
        url: "/utils/meapkeyparse",
        method: "POST",
      },
      get_settings_notifications: {
        authenticated: true,
        url: "/utils/settings_notif/___-probeuid-___",
        method: "GET",
      },
      cloudservers: {
        authenticated: true,
        url: "/utils/cloudservers",
        method: "GET",
      },
      categories: {
        authenticated: true,
        url: "/categories",
        method: "GET",
      },
      settings: {
        authenticated: true,
        url: "/settings.pl",
        method: "POST",
      },
      search: {
        authenticated: true,
        url: "/web/search",
        method: "POST",
      },
      get_notifications: {
        authenticated: true,
        url: "/accounts/notifications",
        method: "GET",
      },
      set_notifications: {
        authenticated: true,
        url: "/accounts/notifications",
        method: "PUT",
      },
    });

    this.SIDEBAR = {
      main: {
        title: null,
        items: [
          {
            type: "page",
            name: "Dashboard",
            icon: "dashboard",
            to: "/dashboard",
            exact: true,
          },
          {
            type: "page",
            name: "Measures list",
            icon: "list",
            to: "/___-probeuid-___/setup",
            exact: true,
          },
          {
            type: "page",
            name: "Gestisci",
            icon: "pencil",
            to: "/measlist/___-probeuid-___/cpanel",
          },
        ],
      },
      probe: {
        //	titleLabel: "Probe",
        title: {
          preload: {
            apiId: "probes",
            params: {
              data: { probeuid: "___-probeuid-___", menu: "1" }, // menu: "1"
            },
          },
          //	link: "/___-probeuid-___/active",
          output: (preloaded_data, loading, active_route_data) => {
            preloaded_data &&
              preloaded_data.sort(function (a, b) {
                return a.name.trim().localeCompare(b.name.trim());
              });

            return (
              <div>
                {/*<div className='text-truncate'>{preloaded_data.name}</div><h6 className='text-truncate text-muted m-0'>{preloaded_data.mac_address}</h6>*/}
                <_LoadingWrapper minHeight loadingPlug={loading}>
                  {preloaded_data ? (
                    <div>
                      <div className="d-flex section-side-title">
                        <div className="flex-grow-1" style={{ width: "200px" }}>
                          {(() => {
                            let _current_probe_data = preloaded_data.find(
                              (_C_entry) => {
                                return this.isCloud()
                                  ? _C_entry.mac_address.replace(/:/g, "") ==
                                      active_route_data.match.params.probeuid
                                  : "edge" ==
                                      active_route_data.match.params.probeuid;
                              },
                            );
                            return (
                              <LinkContainer
                                className="no-style"
                                to={
                                  "/" +
                                  active_route_data.match.params.probeuid +
                                  "/" +
                                  (active_route_data.match.params.status ==
                                  undefined
                                    ? "active"
                                    : active_route_data.match.params.status)
                                  // (this.getChildContext()
                                  //   .app.getLocalStorageService()
                                  //   .isSet("nav_position")
                                  //   ? this.getChildContext()
                                  //       .app.getLocalStorageService()
                                  //       .get("nav_position")
                                  //   : "active")
                                }
                                onClick={() => {
                                  this.getChildContext()
                                    .app.getActionsShelfService()
                                    .do(
                                      "_LayoutSidebar",
                                      "request_close_sidebar",
                                    );
                                }}
                              >
                                <a
                                  href={
                                    "/" +
                                    active_route_data.match.params.probeuid +
                                    "/" +
                                    (active_route_data.match.params.status ==
                                    undefined
                                      ? "active"
                                      : active_route_data.match.params.status)
                                  }
                                >
                                  <div
                                    // style={{ paddingLeft: "1.2em" }}
                                    className="pl-2 py-3 pr-0 h-100"
                                  >
                                    <div
                                      className={
                                        this.isCloud()
                                          ? "text-muted mb-2 ml-3"
                                          : "text-muted mb-2 ml-4"
                                      }
                                    >
                                      <small>
                                        <strong>
                                          PROBE
                                          {_current_probe_data &&
                                          _current_probe_data.probe_status &&
                                          _current_probe_data.probe_status ==
                                            "not_deployed"
                                            ? "not deployed"
                                            : null}
                                          {_current_probe_data &&
                                          _current_probe_data.probe_status &&
                                          _current_probe_data.probe_status ==
                                            "maintenance"
                                            ? "in maintenance"
                                            : null}
                                        </strong>
                                      </small>
                                    </div>
                                    <div
                                      className={
                                        "d-flex align-items-start" +
                                        (this.isCloud() ? "" : " ml-4")
                                      }
                                    >
                                      {this.isCloud() && (
                                        <span className="pr-1 status-dot flex-shrink-0">
                                          <span
                                            className={`${
                                              _current_probe_data?.sync_status &&
                                              _current_probe_data?.sync_status ==
                                                1
                                                ? "text-success"
                                                : "text-danger"
                                            } icon-dot-01`}
                                          />
                                        </span>
                                      )}
                                      <div style={{ minWidth: 0 }}>
                                        <h5
                                          className="trnc mb-0"
                                          title={
                                            _current_probe_data
                                              ? _current_probe_data.name
                                              : null
                                          }
                                        >
                                          {_current_probe_data
                                            ? _current_probe_data.name
                                            : "-"}
                                        </h5>
                                        <div
                                          onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            this.getChildContext()
                                              .app.getLocalStorageService()
                                              .set(
                                                "dashboard_view_mode",
                                                "map",
                                              );
                                            this.getChildContext()
                                              .app.getLocalStorageService()
                                              .set(
                                                "probeMapFocus",
                                                _current_probe_data.mac_address.replace(
                                                  /:/g,
                                                  "",
                                                ),
                                              );
                                            window.open(
                                              this.APP_CONF.BASENAME +
                                                "/dashboard",
                                            );
                                          }}
                                          className="mt-1 text-muted"
                                        >
                                          <small>
                                            <small className="mr-1 icon-location" />
                                            {_current_probe_data
                                              ? _current_probe_data.mac_address
                                              : "-"}
                                          </small>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </a>
                              </LinkContainer>
                            );
                          })()}
                        </div>
                        {this.isCloud() &&
                        this.getChildContext().app.authHandler.getAccountData()
                          .probe_number > 1 ? (
                          <ReactOButton
                            text
                            className="align-self-stretch d-flex align-items-center px-2"
                            onClick={() => {
                              this._collapse_controller.toggle();
                            }}
                          >
                            <h1>
                              <span
                                className={
                                  this.state._collapse_controller == false
                                    ? "icon-caret-down-outline"
                                    : "icon-caret-up-outline"
                                }
                              />
                            </h1>
                          </ReactOButton>
                        ) : null}
                      </div>

                      {this.isCloud() &&
                      this.getChildContext().app.authHandler.getAccountData()
                        .probe_number > 1 ? (
                        <ReactOCollapse
                          className=""
                          onControllerReady={(_collapse_controller) => {
                            this._collapse_controller = _collapse_controller;
                            this.setState({ _collapse_controller: false });
                          }}
                          onOpened={() => {
                            this.setState({ _collapse_controller: true });
                          }}
                          onClosed={() => {
                            this.setState({ _collapse_controller: false });
                          }}
                        >
                          {/* DEPLOYED */}
                          {preloaded_data.filter((_C_probe) => {
                            return _C_probe.probe_status == "deployed";
                          }).length == 0 ||
                          (preloaded_data.filter((_C_probe) => {
                            return _C_probe.probe_status == "deployed";
                          }).length == 1 &&
                            preloaded_data
                              .filter((_C_probe) => {
                                return _C_probe.probe_status == "deployed";
                              })[0]
                              .mac_address.replace(/:/g, "") ==
                              this.getChildContext().app.activeRouteData.match
                                .params.probeuid) ? null : (
                            <div>
                              <div className="pl-4 py-1 subsection-side-title-first">
                                <strong className="side-title-2">
                                  DEPLOYED (
                                  {
                                    preloaded_data.filter((_C_probe) => {
                                      return (
                                        _C_probe.probe_status == "deployed"
                                      );
                                    }).length
                                  }
                                  )
                                </strong>
                              </div>

                              {preloaded_data
                                .filter((_C_probe) => {
                                  // console.log(
                                  //   "qui",
                                  // this.getChildContext().app.activeRouteData.match
                                  //   .params.probeuid
                                  // );
                                  return (
                                    _C_probe.probe_status == "deployed" &&
                                    _C_probe.mac_address.replace(/:/g, "") !=
                                      this.getChildContext().app.activeRouteData
                                        .match.params.probeuid
                                  );
                                })
                                .map((_C_probe_data, _C_idx) => {
                                  return (
                                    <LinkContainer
                                      key={_C_idx}
                                      className="no-style"
                                      to={
                                        "/" +
                                        _C_probe_data.mac_address.replace(
                                          /:/g,
                                          "",
                                        ) +
                                        "/" +
                                        (this.getPath() ||
                                          active_route_data.match.params
                                            .status ||
                                          "active")
                                      }
                                      onClick={() => {
                                        this._collapse_controller.toggle();
                                        this.getChildContext()
                                          .app.getActionsShelfService()
                                          .do(
                                            "_LayoutSidebar",
                                            "request_close_sidebar",
                                          );
                                      }}
                                    >
                                      <a
                                        href={
                                          "/" +
                                          _C_probe_data.mac_address.replace(
                                            /:/g,
                                            "",
                                          ) +
                                          "/" +
                                          (this.getPath() ||
                                            active_route_data.match.params
                                              .status ||
                                            "active")
                                        }
                                      >
                                        <div
                                          className={
                                            this.getChildContext().app
                                              .activeRouteData.match.params
                                              .probeuid ==
                                            _C_probe_data.mac_address.replace(
                                              /:/g,
                                              "",
                                            )
                                              ? "px-2 py-2"
                                              : "px-3 py-1" +
                                                (_C_idx == 0 ? " pt-3" : "") +
                                                (_C_idx ==
                                                preloaded_data.length - 1
                                                  ? " pb-3"
                                                  : "")
                                          }
                                          style={{
                                            backgroundColor:
                                              this.getChildContext().app
                                                .activeRouteData.match.params
                                                .probeuid ==
                                              _C_probe_data.mac_address.replace(
                                                /:/g,
                                                "",
                                              )
                                                ? ""
                                                : "white",

                                            color:
                                              this.getChildContext().app
                                                .activeRouteData.match.params
                                                .probeuid ==
                                              _C_probe_data.mac_address.replace(
                                                /:/g,
                                                "",
                                              )
                                                ? "#337ab7"
                                                : "",
                                            borderLeft:
                                              this.getChildContext().app
                                                .activeRouteData.match.params
                                                .probeuid ==
                                              _C_probe_data.mac_address.replace(
                                                /:/g,
                                                "",
                                              )
                                                ? "0.5em solid #337ab7"
                                                : "",
                                          }}
                                        >
                                          <div className="d-flex align-items-start">
                                            <span className="pr-1 status-dot flex-shrink-0">
                                              <span
                                                className={`${
                                                  _C_probe_data.sync_status &&
                                                  _C_probe_data.sync_status ==
                                                    1
                                                    ? "text-success"
                                                    : "text-danger"
                                                } icon-dot-01`}
                                              />
                                            </span>
                                            <div style={{ minWidth: 0 }}>
                                              <h6
                                                className="trnc mb-0"
                                                title={_C_probe_data.name}
                                              >
                                                {_C_probe_data.name}
                                              </h6>
                                              <div
                                                className={
                                                  this.getChildContext().app
                                                    .activeRouteData.match
                                                    .params.probeuid ==
                                                  _C_probe_data.mac_address.replace(
                                                    /:/g,
                                                    "",
                                                  )
                                                    ? ""
                                                    : "text-muted"
                                                }
                                              >
                                                <small>
                                                  {_C_probe_data.mac_address}
                                                </small>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </a>
                                    </LinkContainer>
                                  );
                                })}
                            </div>
                          )}

                          {preloaded_data.filter((_C_probe) => {
                            return _C_probe.probe_status == "maintenance";
                          }).length == 0 ||
                          (preloaded_data.filter((_C_probe) => {
                            return _C_probe.probe_status == "maintenance";
                          }).length == 1 &&
                            preloaded_data
                              .filter((_C_probe) => {
                                return _C_probe.probe_status == "maintenance";
                              })[0]
                              .mac_address.replace(/:/g, "") ==
                              this.getChildContext().app.activeRouteData.match
                                .params.probeuid) ? null : (
                            <div>
                              <div className="pl-4 py-1 subsection-side-title">
                                <strong className="side-title-2">
                                  MAINTENANCE (
                                  {
                                    preloaded_data.filter((_C_probe) => {
                                      return (
                                        _C_probe.probe_status == "maintenance"
                                      );
                                    }).length
                                  }
                                  )
                                </strong>
                              </div>

                              {preloaded_data
                                .filter((_C_probe) => {
                                  return (
                                    _C_probe.probe_status == "maintenance" &&
                                    _C_probe.mac_address.replace(/:/g, "") !=
                                      this.getChildContext().app.activeRouteData
                                        .match.params.probeuid
                                  );
                                })
                                .map((_C_probe_data, _C_idx) => {
                                  return (
                                    <LinkContainer
                                      key={_C_idx}
                                      className="no-style"
                                      to={
                                        "/" +
                                        _C_probe_data.mac_address.replace(
                                          /:/g,
                                          "",
                                        ) +
                                        "/" +
                                        (this.getPath() ||
                                          active_route_data.match.params
                                            .status ||
                                          "active")
                                      }
                                      onClick={() => {
                                        this._collapse_controller.toggle();
                                        this.getChildContext()
                                          .app.getActionsShelfService()
                                          .do(
                                            "_LayoutSidebar",
                                            "request_close_sidebar",
                                          );
                                      }}
                                    >
                                      <a
                                        href={
                                          "/" +
                                          _C_probe_data.mac_address.replace(
                                            /:/g,
                                            "",
                                          ) +
                                          "/" +
                                          (this.getPath() ||
                                            active_route_data.match.params
                                              .status ||
                                            "active")
                                        }
                                      >
                                        <div
                                          className={
                                            "px-3 py-1 bg-white" +
                                            (_C_idx == 0 ? " pt-3" : "") +
                                            (_C_idx == preloaded_data.length - 1
                                              ? " pb-3"
                                              : "")
                                          }
                                        >
                                          <div className="d-flex align-items-start">
                                            <span className="pr-1 status-dot flex-shrink-0">
                                              <span
                                                className={`${
                                                  _C_probe_data.sync_status &&
                                                  _C_probe_data.sync_status ==
                                                    1
                                                    ? "text-success"
                                                    : "text-danger"
                                                } icon-dot-01`}
                                              />
                                            </span>
                                            <div style={{ minWidth: 0 }}>
                                              <h6
                                                className="trnc mb-0"
                                                title={_C_probe_data.name}
                                              >
                                                {_C_probe_data.name}
                                              </h6>
                                              <div className="text-muted">
                                                <small>
                                                  {_C_probe_data.mac_address}
                                                </small>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </a>
                                    </LinkContainer>
                                  );
                                })}
                            </div>
                          )}

                          {preloaded_data.filter((_C_probe) => {
                            return _C_probe.probe_status == "not_deployed";
                          }).length == 0 ||
                          (preloaded_data.filter((_C_probe) => {
                            return _C_probe.probe_status == "not_deployed";
                          }).length == 1 &&
                            preloaded_data
                              .filter((_C_probe) => {
                                return _C_probe.probe_status == "not_deployed";
                              })[0]
                              .mac_address.replace(/:/g, "") ==
                              this.getChildContext().app.activeRouteData.match
                                .params.probeuid) ? null : (
                            <div>
                              <div className="pl-4 py-1 subsection-side-title">
                                <strong className="side-title-2">
                                  NOT DEPLOYED (
                                  {
                                    preloaded_data.filter((_C_probe) => {
                                      return (
                                        _C_probe.probe_status == "not_deployed"
                                      );
                                    }).length
                                  }
                                  )
                                </strong>
                              </div>

                              {preloaded_data
                                .filter((_C_probe) => {
                                  return (
                                    _C_probe.probe_status == "not_deployed" &&
                                    _C_probe.mac_address.replace(/:/g, "") !=
                                      this.getChildContext().app.activeRouteData
                                        .match.params.probeuid
                                  );
                                })
                                .map((_C_probe_data, _C_idx) => {
                                  return (
                                    <LinkContainer
                                      key={_C_idx}
                                      className="no-style"
                                      to={
                                        "/" +
                                        _C_probe_data.mac_address.replace(
                                          /:/g,
                                          "",
                                        ) +
                                        "/" +
                                        (this.getPath() ||
                                          active_route_data.match.params
                                            .status ||
                                          "active")
                                      }
                                      onClick={() => {
                                        this._collapse_controller.toggle();
                                        this.getChildContext()
                                          .app.getActionsShelfService()
                                          .do(
                                            "_LayoutSidebar",
                                            "request_close_sidebar",
                                          );
                                      }}
                                    >
                                      <a
                                        href={
                                          "/" +
                                          _C_probe_data.mac_address.replace(
                                            /:/g,
                                            "",
                                          ) +
                                          "/" +
                                          (this.getPath() ||
                                            active_route_data.match.params
                                              .status ||
                                            "active")
                                        }
                                      >
                                        <div
                                          className={
                                            "px-3 py-1 bg-white" +
                                            (_C_idx == 0 ? " pt-3" : "") +
                                            (_C_idx == preloaded_data.length - 1
                                              ? " pb-3"
                                              : "")
                                          }
                                        >
                                          <div className="d-flex align-items-start">
                                            <span className="pr-1 status-dot flex-shrink-0">
                                              <span
                                                className={`${
                                                  _C_probe_data.sync_status &&
                                                  _C_probe_data.sync_status ==
                                                    1
                                                    ? "text-success"
                                                    : "text-danger"
                                                } icon-dot-01`}
                                              />
                                            </span>
                                            <div style={{ minWidth: 0 }}>
                                              <h6
                                                className="trnc mb-0"
                                                title={_C_probe_data.name}
                                              >
                                                {_C_probe_data.name}
                                              </h6>
                                              <div className="text-muted">
                                                <small>
                                                  {_C_probe_data.mac_address}
                                                </small>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </a>
                                    </LinkContainer>
                                  );
                                })}
                            </div>
                          )}
                        </ReactOCollapse>
                      ) : null}
                    </div>
                  ) : null}
                </_LoadingWrapper>
              </div>
            );
          },
        },
        items: [
          {
            type: "page",
            name: "Measures results",
            icon: "graph-bar",
            to: "/___-probeuid-___/active",
            position: "active",
            isActive: (match, location) => {
              return /\/(active)[/]*/.test(location.pathname);
            },
            sub_menu: [
              {
                type: "page",
                name: "Active",
                icon: "graph-bar",
                position: "active",
                to: "/___-probeuid-___/active",
              },
              {
                type: "page",
                name: "Archived",
                icon: "archive",
                position: "archived",
                to: "/___-probeuid-___/archived",
              },
            ],
            //	exact: true
          },
          {
            privileges: "ADMIN",
            type: "page",
            name: "Measures setup",
            position: "config",
            icon: "pencil",
            to: "/___-probeuid-___/config",
            //	exact: true
          },
          {
            privileges: "ADMIN",
            type: "page",
            name: "Device setup",
            position: "setup",
            icon: "settings",
            to: "/___-probeuid-___/setup",
            //	exact: true
          },
          {
            type: "page",
            name: "Spectrum",
            icon: "spectro",
            position: "spectro",
            to: "/___-probeuid-___/spectro",
            // preload: {
            // 	apiId: 'probe_capabilities',
            // 	params: {
            // 		data: {probeuid: '___-probeuid-___'}
            // 	}
            // },
            enabledIf: (preloaded_data) => {
              return preloaded_data.spectro && preloaded_data.spectro == "yes";
            },
          },
          {
            type: "page",
            name: "AP coverage",
            icon: "router",
            position: "apcoverage",
            to: "/___-probeuid-___/apcoverage",
            // preload: {
            // 	apiId: 'probe_cst_sync_status',
            // 	params: {
            // 		data: {probeuid: '___-probeuid-___'}
            // 	}
            // },
            enabled: () => {
              return (
                this.getChildContext().app.authHandler.getAccountData()
                  .APcoverage == "yes"
              );
            },
            //	exact: true
          },
          {
            type: "page",
            name: "Archived / Paused",
            icon: "archive",
            position: "archived",
            to: "/___-probeuid-___/archived",
            cloud: true,
            isActive: (match, location) => {
              return /\/(archived|paused)[/]*/.test(location.pathname);
            },
            //	exact: true
          },
          // {
          //   type: "page",
          //   name: "User Tests",
          //   position: "usertests",
          //   icon: "list-2",
          //   to: "/___-probeuid-___/usertests",
          //   //	exact: true
          // },
        ],
      },
    };

    this.HEADER_RIGHT = [
      {
        type: "custom",
        render: (_C_idx, app_context, props) => {
          return app_context.isCloud() &&
            !app_context.authHandler.getAccountData().message ? (
            [
              <li key={_C_idx + ".1"} className="nav-item px-1">
                {!app_context.authHandler.getAccountData()
                  .smart_notifications ||
                app_context.authHandler.getAccountData().smart_notifications !=
                  "yes" ? (
                  <>
                    <Input
                      className="form-control"
                      type="text"
                      placeholder="Search"
                      // onKeyPress={(e) => {
                      //   if (e.key == "Enter") {
                      //     this.manualSearch = true;
                      //     app_context
                      //       .getActionsShelfService()
                      //       .do("searchActions", "updateQuery", e.target.value);
                      //   }
                      // }}
                      onChange={(e) => {
                        // delay
                        this.globalTime = Date.now();
                        let singleTime = Date.now();
                        let string = e.target.value;
                        if (string != "") {
                          this.setState({ searchSpin: true });
                          setTimeout(() => {
                            this.delay(singleTime, string, app_context);
                          }, 800);
                        } else {
                          this.setState({ searchSpin: false });
                        }
                      }}
                    />
                    {this.state.searchSpin == true ? (
                      <span className="search-spin">
                        <ClipLoader
                          color={app_context.colors.primary}
                          size={15}
                          margin="5px"
                        />
                      </span>
                    ) : null}
                  </>
                ) : null}
              </li>,
              <li
                key={_C_idx + ".2"}
                className="nav-item dropdown account-nav-item"
              >
                {!app_context.media.isMobile ? (
                  <div
                    className="nav-link dropdown-toggle"
                    data-toggle="dropdown"
                    role="button"
                    aria-haspopup="true"
                    aria-expanded="false"
                    style={{ cursor: "pointer" }}
                  >
                    {(props && props.user) || "-"}
                    {/* {this.getChildContext() &&
                      this.getChildContext().app.authHandler.getAccountData().user} */}
                  </div>
                ) : null}
                <div
                  className={
                    !app_context.media.isMobile
                      ? "dropdown-menu dropdown-menu-right"
                      : "text-left"
                  }
                >
                  <div>
                    {app_context.authHandler.getAccountData().alias == "no" ? (
                      <span>
                        <NavLink to="/account" className="dropdown-item">
                          <span className="icon-user mr-2" />
                          Account
                        </NavLink>
                        <div className="dropdown-divider"></div>
                      </span>
                    ) : null}
                    {/* NOTIFICATION SETTINGS */}
                    <span>
                      <NavLink
                        to="/notifications-settings"
                        className="dropdown-item"
                      >
                        <span className="icon-envelop mr-2" />
                        Notifications
                      </NavLink>
                      <div className="dropdown-divider"></div>
                    </span>
                    {/* LOGIN MANAGEMENT */}
                    {this.isCloud() &&
                    app_context.authHandler.getAccountData().ExternalLogin ==
                      "yes" &&
                    app_context.authHandler.getAccountData().type == "ADMIN" ? (
                      <span>
                        <NavLink to="/loginconf" className="dropdown-item">
                          <span className="icon-users mr-2" />
                          Login management
                        </NavLink>
                        <div className="dropdown-divider"></div>
                      </span>
                    ) : null}
                    {/* PROBES SETTINGS */}
                    <NavLink to="/probconf" className="dropdown-item">
                      <span className="icon-wrench mr-2" />
                      Probes
                    </NavLink>
                    {app_context.authHandler.getAccountData().SDmeasure ==
                    "yes" ? (
                      <span>
                        <div className="dropdown-divider"></div>
                        <NavLink to="/sdconf" className="dropdown-item">
                          <span className="icon-settings mr-2" />
                          SD configuration
                        </NavLink>
                      </span>
                    ) : null}
                    {this.getChildContext().app.platformName() ==
                      "WiFiProbe" && (
                      <div>
                        <div className="dropdown-divider"></div>
                        <div className="dropdown-item">
                          <a
                            href="/viewer/wfp_quick_guide.pdf"
                            style={{ textDecoration: "none", color: "inherit" }}
                            target="_blank"
                          >
                            <span className="icon-download mr-2" />
                            Quick guide (PDF)
                          </a>
                        </div>
                      </div>
                    )}
                    <div className="dropdown-divider"></div>
                    <NavLink
                      to="#"
                      isActive={(match, location) => {
                        // console.log("match", match);
                        // console.log("location", location);
                      }}
                      className="dropdown-item"
                      onClick={() => {
                        if (
                          this.getChildContext()
                            .app.getLocalStorageService()
                            .isSet("search_persistent_state")
                        ) {
                          this.getChildContext()
                            .app.getLocalStorageService()
                            .remove("search_persistent_state");
                        }
                        app_context
                          .getActionsShelfService()
                          .do("authHandlerActions", "logout");
                      }}
                    >
                      <span className="icon-logout mr-2" />
                      Logout
                    </NavLink>
                  </div>
                </div>
              </li>,
            ]
          ) : (
            <div
              key={_C_idx}
              className="nav-link"
              href="#"
              style={{
                cursor: "pointer",
                ...(app_context.authHandler.getAccountData().message && {
                  textTransform: "none",
                }),
              }}
            >
              <span
                onClick={() => {
                  this.getChildContext().app.setUrlParams("");
                  if (
                    this.getChildContext()
                      .app.getLocalStorageService()
                      .isSet("search_persistent_state")
                  ) {
                    this.getChildContext()
                      .app.getLocalStorageService()
                      .remove("search_persistent_state");
                  }
                  app_context
                    .getActionsShelfService()
                    .do("authHandlerActions", "logout");
                }}
              >
                <span className="icon-logout mr-2" />
                <span>Logout</span>
              </span>
              {app_context.authHandler.getAccountData().message && (
                <span className="ml-2">
                  {app_context.authHandler.getAccountData().user}
                </span>
              )}
            </div>
          );
        },
      },
    ];

    this.ROUTES = {
      home: {
        pathname: "/dashboard",
        search: "?view",
      },
      login: "/login",
      //	fixed: SearchResults,
      reserved: {
        //				'/apitester': {
        //					exact: true,
        //					layoutType: 'page',				// 'page': Solo header | 'single-page': No header, no sidebar | 'page-admin': Header e sidebar
        //					sidebarMenu: this.SIDEBAR.main,
        //					sidebarMenu2: this.SIDEBAR.probe,
        //					component: [
        //						{
        //							component: ApiTester,
        //							props: {
        //							//	preLoadCommons: 'settings'
        //							}
        //						}
        //					],
        //					leftHeaderMenu: [],
        //					rightHeaderMenu: [
        //						{
        //							type: "action",
        //							icon: 'logout',
        //							action_params: ['authHandlerActions', 'logout'],
        //							name: "Logout"
        //						}
        //					]
        //				},
        "/dashboard": {
          exact: true,
          layoutType: "page", // 'page': Solo header | 'single-page': No header, no sidebar | 'page-admin': Header e sidebar
          sidebarMenu: this.SIDEBAR.main,
          component: [
            {
              component: Dashboard,
              props: {
                // preLoadCommons: "settings",
              },
            },
          ],
          leftHeaderMenu: [
            //	{
            //		type: "page",
            //		name: "Conf mockup",
            //		to: "/procentecmockup"
            //	}
          ],
          rightHeaderMenu: this.HEADER_RIGHT,
        },
        "/account": {
          exact: true,
          layoutType: "page", // 'page': Solo header | 'single-page': No header, no sidebar | 'page-admin': Header e sidebar
          component: [
            {
              component: Account,
              props: {
                //	preLoadCommons: 'settings'
              },
            },
          ],
          leftHeaderMenu: [
            {
              type: "page",
              to: "/dashboard",
              name: "Dashboard",
              icon: "dashboard",
              cloud: true,
            },
          ],
          rightHeaderMenu: this.HEADER_RIGHT,
        },
        "/probconf": {
          layoutType: "page", // 'page': Solo header | 'single-page': No header, no sidebar | 'page-admin': Header e sidebar
          sidebarMenu: this.SIDEBAR.main,
          component: ProbConf,
          rightHeaderMenu: this.HEADER_RIGHT,
        },
        // "/sdconf2": {
        //   layoutType: "page", // 'page': Solo header | 'single-page': No header, no sidebar | 'page-admin': Header e sidebar
        //   sidebarMenu: this.SIDEBAR.main,
        //   component: SdConf,
        //   rightHeaderMenu: this.HEADER_RIGHT,
        // },
        "/sdconf": {
          layoutType: "page", // 'page': Solo header | 'single-page': No header, no sidebar | 'page-admin': Header e sidebar
          sidebarMenu: this.SIDEBAR.main,
          component: SdConf2,
          rightHeaderMenu: this.HEADER_RIGHT,
        },
        "/loginconf": {
          exact: true,
          layoutType: "page", // 'page': Solo header | 'single-page': No header, no sidebar | 'page-admin': Header e sidebar
          sidebarMenu: this.SIDEBAR.main,
          component: UserManagement,
          rightHeaderMenu: this.HEADER_RIGHT,
        },
        "/notifications-settings": {
          layoutType: "page", // 'page': Solo header | 'single-page': No header, no sidebar | 'page-admin': Header e sidebar
          sidebarMenu: this.SIDEBAR.main,
          leftHeaderMenu: [
            {
              type: "page",
              to: "/dashboard",
              name: "Dashboard",
              icon: "dashboard",
              cloud: true,
            },
          ],
          component: NotificationsSettings,
          rightHeaderMenu: this.HEADER_RIGHT,
        },
        "/loginconf/grouplist": {
          exact: true,
          layoutType: "page", // 'page': Solo header | 'single-page': No header, no sidebar | 'page-admin': Header e sidebar
          sidebarMenu: this.SIDEBAR.main,
          component: GroupList,
          rightHeaderMenu: this.HEADER_RIGHT,
        },
        "/dev": {
          layoutType: "page", // 'page': Solo header | 'single-page': No header, no sidebar | 'page-admin': Header e sidebar
          sidebarMenu: this.SIDEBAR.main,
          component: Dev,
          rightHeaderMenu: this.HEADER_RIGHT,
        },
        "/static": {
          layoutType: "page", // 'page': Solo header | 'single-page': No header, no sidebar | 'page-admin': Header e sidebar
          sidebarMenu: this.SIDEBAR.main,
          component: ServicePage,
          rightHeaderMenu: this.HEADER_RIGHT,
        },
        "/logcat": {
          layoutType: "single-page", // 'page': Solo header | 'single-page': No header, no sidebar | 'page-admin': Header e sidebar
          sidebarMenu: this.SIDEBAR.main,
          component: Logcat,
          rightHeaderMenu: this.HEADER_RIGHT,
        },
        "/stepviewer": {
          layoutType: "single-page", // 'page': Solo header | 'single-page': No header, no sidebar | 'page-admin': Header e sidebar
          sidebarMenu: this.SIDEBAR.main,
          component: StepViewer,
          rightHeaderMenu: this.HEADER_RIGHT,
        },
        "/:fontid([a-fA-F0-9]{3})/fontdemo": {
          layoutType: "page", // 'page': Solo header | 'single-page': No header, no sidebar | 'page-admin': Header e sidebar
          sidebarMenu: this.SIDEBAR.main,
          component: FontDemo,
          rightHeaderMenu: this.HEADER_RIGHT,
        },
        "/:probeuid([a-fA-F0-9]{12}|edge)/:status(active|paused|archived)+/:measureid/:bssid/results/:ts/:resid":
          {
            exact: true,
            nav_position: "dynamic",
            layoutType: "page-admin", // 'page': Solo header | 'single-page': No header, no sidebar | 'page-admin': Header e sidebar
            sidebarMenu: this.SIDEBAR.probe,
            component: ProbeMeasureResults,
            leftHeaderMenu: [
              {
                type: "page",
                to: "/dashboard",
                name: "Dashboard",
                icon: "dashboard",
                cloud: true,
              },
            ],
            rightHeaderMenu: this.HEADER_RIGHT,
          },
        "/:probeuid([a-fA-F0-9]{12}|edge)/:status(active|paused|archived)+/aggregate":
          {
            exact: true,
            nav_position: "dynamic",
            layoutType: "page-admin", // 'page': Solo header | 'single-page': No header, no sidebar | 'page-admin': Header e sidebar
            sidebarMenu: this.SIDEBAR.probe,
            component: AggregateMeasuresFlat,
            leftHeaderMenu: [
              {
                type: "page",
                to: "/dashboard",
                name: "Dashboard",
                icon: "dashboard",
                cloud: true,
              },
            ],
            rightHeaderMenu: this.HEADER_RIGHT,
          },
        "/:status(active|paused|archived)+/aggregate": {
          exact: true,
          nav_position: "dynamic",
          layoutType: "page", // 'page': Solo header | 'single-page': No header, no sidebar | 'page-admin': Header e sidebar
          sidebarMenu: this.SIDEBAR.probe,
          component: AggregateMeasuresFlat,
          leftHeaderMenu: [
            {
              type: "page",
              to: "/dashboard",
              name: "Dashboard",
              icon: "dashboard",
              cloud: true,
            },
          ],
          rightHeaderMenu: this.HEADER_RIGHT,
        },
        "/:status(active|paused|archived)+/aggregate/overal": {
          exact: true,
          nav_position: "dynamic",
          layoutType: "page", // 'page': Solo header | 'single-page': No header, no sidebar | 'page-admin': Header e sidebar
          sidebarMenu: this.SIDEBAR.probe,
          component: ProbeMeasureExplorerAggregate,
          leftHeaderMenu: [
            {
              type: "page",
              to: "/dashboard",
              name: "Dashboard",
              icon: "dashboard",
              cloud: true,
            },
          ],
          rightHeaderMenu: this.HEADER_RIGHT,
        },
        "/:probeuid([a-fA-F0-9]{12}|edge)/:status(active|paused|archived)+/:measureid/:bssid/:initview":
          {
            exact: false,
            strict: false,
            nav_position: "dynamic",
            layoutType: "page-admin", // 'page': Solo header | 'single-page': No header, no sidebar | 'page-admin': Header e sidebar
            sidebarMenu: this.SIDEBAR.probe,
            component: ProbeMeasureExplorer,
            leftHeaderMenu: [
              {
                type: "page",
                to: "/dashboard",
                name: "Dashboard",
                icon: "dashboard",
                cloud: true,
              },
            ],
            rightHeaderMenu: this.HEADER_RIGHT,
          },
        "/:probeuid([a-fA-F0-9]{12}|edge)/:status(active|paused|archived)+/:measureid/:bssid":
          {
            exact: false,
            strict: false,
            nav_position: "dynamic",
            layoutType: "page-admin", // 'page': Solo header | 'single-page': No header, no sidebar | 'page-admin': Header e sidebar
            sidebarMenu: this.SIDEBAR.probe,
            component: ProbeMeasureExplorer,
            leftHeaderMenu: [
              {
                type: "page",
                to: "/dashboard",
                name: "Dashboard",
                icon: "dashboard",
                cloud: true,
              },
            ],
            rightHeaderMenu: this.HEADER_RIGHT,
          },
        "/:probeuid([a-fA-F0-9]{12}|edge)/:status(active|paused|archived)+/:measureid":
          {
            exact: true,
            nav_position: "dynamic",
            layoutType: "page-admin", // 'page': Solo header | 'single-page': No header, no sidebar | 'page-admin': Header e sidebar
            sidebarMenu: this.SIDEBAR.probe,
            component: ProbeMeasures,
            leftHeaderMenu: [
              {
                type: "page",
                to: "/dashboard",
                name: "Dashboard",
                icon: "dashboard",
                cloud: true,
              },
            ],
            rightHeaderMenu: this.HEADER_RIGHT,
          },
        "/:probeuid([a-fA-F0-9]{12}|edge)/:status(active|paused|archived)+": {
          exact: true,
          nav_position: "dynamic",
          layoutType: "page-admin", // 'page': Solo header | 'single-page': No header, no sidebar | 'page-admin': Header e sidebar
          sidebarMenu: this.SIDEBAR.probe,
          component: ProbeMeasures,
          leftHeaderMenu: [
            {
              type: "page",
              to: "/dashboard",
              name: "Dashboard",
              icon: "dashboard",
              cloud: true,
            },
          ],
          rightHeaderMenu: this.HEADER_RIGHT,
        },
        "/:probeuid([a-fA-F0-9]{12}|edge)/setup": {
          //					exact: true,
          layoutType: "page-admin", // 'page': Solo header | 'single-page': No header, no sidebar | 'page-admin': Header e sidebar
          privileges: "ADMIN",
          nav_position: "setup",
          setup_position: "",
          sidebarMenu: this.SIDEBAR.probe,
          component: ProbeSetup,
          leftHeaderMenu: [
            {
              type: "page",
              to: "/dashboard",
              name: "Dashboard",
              icon: "dashboard",
              cloud: true,
            },
          ],
          rightHeaderMenu: this.HEADER_RIGHT,
          subroutes: {
            "/:probeuid([a-fA-F0-9]{12}|edge)/setup/general": {
              layoutType: "page-admin", // 'page': Solo header | 'single-page': No header, no sidebar | 'page-admin': Header e sidebar
              component: ProbeSetupGeneral,
              nav_position: "setup",
              setup_position: "",
            },

            "/:probeuid([a-fA-F0-9]{12}|edge)/setup/wifi": {
              layoutType: "page-admin", // 'page': Solo header | 'single-page': No header, no sidebar | 'page-admin': Header e sidebar
              component: ProbeSetupWifi,
              nav_position: "setup",
              setup_position: "wifi",
            },
            "/:probeuid([a-fA-F0-9]{12}|edge)/setup/teams": {
              layoutType: "page-admin", // 'page': Solo header | 'single-page': No header, no sidebar | 'page-admin': Header e sidebar
              component: Teams,
              nav_position: "setup",
              setup_position: "teams",
            },
            "/:probeuid([a-fA-F0-9]{12}|edge)/setup/ethernet": {
              layoutType: "page-admin", // 'page': Solo header | 'single-page': No header, no sidebar | 'page-admin': Header e sidebar
              component: ProbeSetupEthernet,
              nav_position: "setup",
              setup_position: "ethernet",
            },
            "/:probeuid([a-fA-F0-9]{12}|edge)/setup/users": {
              layoutType: "page-admin", // 'page': Solo header | 'single-page': No header, no sidebar | 'page-admin': Header e sidebar
              component: ProbeSetupUsers,
              nav_position: "setup",
              setup_position: "users",
            },
            "/:probeuid([a-fA-F0-9]{12}|edge)/setup/usb": {
              layoutType: "page-admin", // 'page': Solo header | 'single-page': No header, no sidebar | 'page-admin': Header e sidebar
              component: ProbeSetupUsb,
              nav_position: "setup",
              setup_position: "usb",
            },
            "/:probeuid([a-fA-F0-9]{12}|edge)/setup/signthold": {
              layoutType: "page-admin", // 'page': Solo header | 'single-page': No header, no sidebar | 'page-admin': Header e sidebar
              component: ProbeSetupSignalTHold,
              nav_position: "setup",
              setup_position: "signthold",
            },
            "/:probeuid([a-fA-F0-9]{12}|edge)/setup/sync": {
              layoutType: "page-admin", // 'page': Solo header | 'single-page': No header, no sidebar | 'page-admin': Header e sidebar
              component: ProbeSetupSync,
              nav_position: "setup",
              setup_position: "sync",
            },
            "/:probeuid([a-fA-F0-9]{12}|edge)/setup/notifications": {
              layoutType: "page-admin", // 'page': Solo header | 'single-page': No header, no sidebar | 'page-admin': Header e sidebar
              component: ProbeSetupNotifications,
              nav_position: "setup",
              setup_position: "notifications",
            },
            "/:probeuid([a-fA-F0-9]{12}|edge)/setup/about": {
              layoutType: "page-admin", // 'page': Solo header | 'single-page': No header, no sidebar | 'page-admin': Header e sidebar
              component: ProbeAbout,
              nav_position: "setup",
              setup_position: "about",
            },
          },
        },
        "/:probeuid([a-fA-F0-9]{12}|edge)/config/:initselection": {
          exact: true,
          layoutType: "page-admin", // 'page': Solo header | 'single-page': No header, no sidebar | 'page-admin': Header e sidebar
          privileges: "ADMIN",
          nav_position: "config",
          sidebarMenu: this.SIDEBAR.probe,
          component: ProbeConfig,
          leftHeaderMenu: [
            {
              type: "page",
              to: "/dashboard",
              name: "Dashboard",
              icon: "dashboard",
              cloud: true,
            },
          ],
          rightHeaderMenu: this.HEADER_RIGHT,
        },
        "/:probeuid([a-fA-F0-9]{12}|edge)/spectro": {
          //					exact: true,
          layoutType: "page-admin", // 'page': Solo header | 'single-page': No header, no sidebar | 'page-admin': Header e sidebar
          privileges: "ADMIN",
          nav_position: "spectro",
          sidebarMenu: this.SIDEBAR.probe,
          component: [
            {
              component: SpectroChart,
              props: {
                sec_to_get: 3600,
                freq: 2400,
                allfreq: 1,
              },
            },
          ],
          leftHeaderMenu: [
            {
              type: "page",
              to: "/dashboard",
              name: "Dashboard",
              icon: "dashboard",
              cloud: true,
            },
          ],
          rightHeaderMenu: this.HEADER_RIGHT,
        },
        "/:probeuid([a-fA-F0-9]{12}|edge)/config": {
          //					exact: true,
          layoutType: "page-admin", // 'page': Solo header | 'single-page': No header, no sidebar | 'page-admin': Header e sidebar
          privileges: "ADMIN",
          nav_position: "config",
          sidebarMenu: this.SIDEBAR.probe,
          component: ProbeConfig,
          leftHeaderMenu: [
            {
              type: "page",
              to: "/dashboard",
              name: "Dashboard",
              icon: "dashboard",
              cloud: true,
            },
          ],
          rightHeaderMenu: this.HEADER_RIGHT,
        },
        // "/:probeuid([a-fA-F0-9]{12}|edge)/config/force": {
        //   //					exact: true,
        //   layoutType: "page-admin", // 'page': Solo header | 'single-page': No header, no sidebar | 'page-admin': Header e sidebar
        //   privileges: "ADMIN",
        //   sidebarMenu: this.SIDEBAR.probe,
        //   component: ProbeConfigForce,
        //   leftHeaderMenu: [
        //     {
        //       type: "page",
        //       to: "/dashboard",
        //       name: "Dashboard",
        //       icon: "dashboard",
        //     },
        //   ],
        //   rightHeaderMenu: this.HEADER_RIGHT,
        // },
        // AP DATA ROUTE
        "/:probeuid([a-fA-F0-9]{12}|edge)/apcoverage": {
          // exact: true,
          layoutType: "page-admin", // 'page': Solo header | 'single-page': No header, no sidebar | 'page-admin': Header e sidebar
          privileges: "ADMIN",
          nav_position: "apcoverage",
          sidebarMenu: this.SIDEBAR.probe,
          component: ApCoverage,
          leftHeaderMenu: [
            {
              type: "page",
              to: "/dashboard",
              name: "Dashboard",
              icon: "dashboard",
              cloud: true,
            },
          ],
          rightHeaderMenu: this.HEADER_RIGHT,
        },

        // "/:probeuid([a-fA-F0-9]{12}|edge)/usertests": {
        //   exact: true,
        //   layoutType: "page-admin",
        //   nav_position: "usertests",
        //   sidebarMenu: this.SIDEBAR.probe, // 'page': Solo header | 'single-page': No header, no sidebar | 'page-admin': Header e sidebar
        //   component: ProbeUserTests,
        //   leftHeaderMenu: [
        //     {
        //       type: "page",
        //       to: "/dashboard",
        //       name: "Dashboard",
        //       icon: "dashboard",
        //     },
        //   ],
        //   rightHeaderMenu: this.HEADER_RIGHT,
        // },

        "/search": {
          //					exact: true,
          layoutType: "page", // 'page': Solo header | 'single-page': No header, no sidebar | 'page-admin': Header e sidebar
          component: SearchResults,
          leftHeaderMenu: [
            {
              type: "page",
              to: "/dashboard",
              name: "Dashboard",
              icon: "dashboard",
              cloud: true,
            },
          ],
          rightHeaderMenu: this.HEADER_RIGHT,
        },
      },
      public: {
        "/login": {
          layoutType: "page", // 'page': Solo header | 'single-page': No header, no sidebar | 'page-admin': Header e sidebar
          component: Login,
        },
        //				'/test': {
        //					exact: true,
        //					layoutType: 'page',				// 'page': Solo header | 'single-page': No header, no sidebar | 'page-admin': Header e sidebar
        //					component: [
        //						{
        //							component: Test,
        //							props: {
        //							//	preLoadCommons: 'settings'
        //							}
        //						}
        //					],
        //					leftHeaderMenu: [
        //						{
        //							type: "page",
        //							to: "/dashboard",
        //							name: "Dashboard",
        //							icon: "dashboard"
        //						}
        //					],
        //					rightHeaderMenu: []
        //				},
        //				'/procentecmockup': {
        //					exact: true,
        //					layoutType: 'page',				// 'page': Solo header | 'single-page': No header, no sidebar | 'page-admin': Header e sidebar
        //					component: [
        //						{
        //							component: ConfMockup,
        //							props: {
        //							//	preLoadCommons: 'settings'
        //							}
        //						}
        //					]
        //				}
      },
    };
  }

  // getUrlParams() {
  //   console.log("trigger func");
  //   const urlParams = new URLSearchParams(window.location.search);
  //   const params = Array.from(urlParams.keys());
  //   // console.log("params ->", params);
  //   let search = "?view";
  //   if (params && params.length > 0) {
  //     search = window.location.search;
  //   }
  //   return search;
  // }

  getPath() {
    let path = null;

    const nav_position = this.getChildContext()
      .app.getLocalStorageService()
      .get("nav_position");

    const setup_position = this.getChildContext()
      .app.getLocalStorageService()
      .get("setup_position");

    if (nav_position) {
      if (nav_position == "setup") {
        path = `${nav_position}/${setup_position || ""}`;
      } else {
        path = nav_position;
      }
    }

    return path;
  }

  loadPlatformInfo(cb) {
    this.setState(
      {
        platform_info_loading: true,
      },
      () => {
        this.apiStoreService.fire("platform", {
          ___onSuccess: (status, data) => {
            this.setState(
              {
                platform: data,
                // platform_name: data.platform_name,
                platform_info_loading: false,
              },
              cb || null,
              this.apiStoreService.setIsCloud(data),
              // this.getChildContext()
              //   .app.getLocalStorageService()
              //   .set("platform_name", data.platform_name)
            );
            document.title = data.platform_name;
          },
        });
      },
    );
  }

  isCloud() {
    return this.state.platform.is_cloud;
  }

  alertModal(options) {
    this._alert_modal.open({
      type: options.type,
      title: options.title,
      message: options.message,
      cb: options.cb,
    });
  }

  platformName() {
    return this.state.platform.platform_name;
  }

  setCachedState(objState) {
    this.cachedState = objState;
  }

  handleTSLimit(ts, archived) {
    let dateObj = {};
    // let cloudLimit = 86400 * 740;
    let edgeLimit = 86400 * 70;

    if (!this.isCloud()) {
      let rawlimit = moment().unix() - edgeLimit;
      let limit = rawlimit - (rawlimit % 60);
      let dateParsed = moment(limit, "X").startOf("day");
      if (ts && ts - limit < 3600) {
        dateObj.unsafeTime = true;
      }
      if (ts && ts < limit) {
        dateObj.outOfLimit = true;
      }

      dateObj.infoMsg =
        (dateObj.unsafeTime || dateObj.outOfLimit) &&
        "Oldest measure data: " + moment(limit, "X").format("L LT");
      dateObj.limit = limit;
      dateObj.dateParsed = dateParsed;
    } else {
      const now = archived ? moment(archived) : moment();
      const limit = now.subtract(2, "year").add(1, "days").unix();
      if (ts <= limit) {
        dateObj.outOfLimit = true;
      }
      // console.log("L --->", l);
      // let rawlimit = moment().unix() - cloudLimit;
      // let limit = rawlimit - (rawlimit % 60);
      let dateParsed = moment(limit, "X").startOf("day");
      // if (ts && ts - limit < 3600) {
      //   dateObj.unsafeTime = true;
      // }
      // if (ts && ts < limit) {
      //   dateObj.outOfLimit = true;
      // }
      dateObj.infoMsg =
        dateObj.outOfLimit &&
        "Measure not available before: " + moment(limit, "X").format("L LT");
      dateObj.limit = limit;
      dateObj.dateParsed = dateParsed;
    }

    return dateObj;
  }

  copyURL() {
    // console.log("window from App", window.location);
    const { protocol, hostname, pathname } = window.location;
    const URL = protocol + "//" + hostname + pathname;
    navigator.clipboard.writeText(URL);
  }

  /////////////////////////
  //	Lifecycle methods
  //

  onGetChildContext() {
    return {
      media: {
        isMobile: this.state.isMobile,
        isTablet: this.state.isTablet,
        isDesktop: this.state.isDesktop,
        isDesktopXl: this.state.isDesktopXl,
        isDesktopSidebarOpen: this.state.isDesktopSidebarOpen,
        customWidth: this.state.customWidth,
      },
      cachedState: this.cachedState,
      setCachedState: this.setCachedState.bind(this),
      isCloud: this.isCloud.bind(this),
      alert: this.alertModal.bind(this),
      platformName: this.platformName.bind(this),
      handleTSLimit: this.handleTSLimit.bind(this),
      copyURL: this.copyURL.bind(this),
      momentjs: moment,
      freqToLabel: (freq) => {
        let _freq =
          freq && typeof freq == "object" && freq.curr_f
            ? freq.curr_f
            : freq
              ? freq
              : null;
        return _freq && !isNaN(_freq) ? (
          <Badge
            pill
            className={
              (_freq < 5000
                ? "text-secondary border-secondary"
                : _freq < 5925
                  ? "text-primary border-primary"
                  : "text-purple border-purple") + " border bg-light"
            }
          >
            {_freq < 5000 ? "2.4GHz" : _freq < 5925 ? "5GHz" : "6GHz"}
          </Badge>
        ) : null;
      },
    };
  }

  onComponentDidMount() {
    // console.log("DEBUG :: App -> componentDidMount", APP_CONF.SERVER_URL);
    // const ref = document.referrer;
    // if (ref.includes(window.location.host)) {
    //   console.log("Arrivo da una pagina interna");
    // } else {
    //   console.log("Arrivo da esterno o referrer vuoto");
    // }
    this.props.media({ maxWidth: 576 }, () => {
      this.setState({
        isMobile: true,
        isTablet: false,
        isDesktop: false,
        isDesktopXl: false,
        isDesktopSidebarOpen: false,
      });
    });
    this.props.media({ minWidth: 576, maxWidth: 768 }, () => {
      this.setState({
        isMobile: false,
        isTablet: true,
        isDesktop: false,
        isDesktopXl: false,
        isDesktopSidebarOpen: false,
      });
    });

    this.props.media({ minWidth: 768, maxWidth: 992 }, () => {
      this.setState({
        isMobile: false,
        isTablet: false,
        isDesktop: true,
        isDesktopXl: false,
        isDesktopSidebarOpen: false,
      });
    });

    this.props.media({ minWidth: 992, maxWidth: 1300 }, () => {
      this.setState({
        isMobile: false,
        isTablet: false,
        isDesktop: false,
        isDesktopXl: true,
        isDesktopSidebarOpen: false,
      });
    });

    this.props.media({ minWidth: 1300 }, () => {
      this.setState({
        isMobile: false,
        isTablet: false,
        isDesktop: false,
        isDesktopXl: false,
        isDesktopSidebarOpen: true,
      });
    });

    this.props.media({ maxWidth: 1624 }, () => {
      this.setState({
        customWidth: true,
      });
    });

    this.props.media({ minWidth: 1624 }, () => {
      this.setState({
        customWidth: false,
      });
    });

    if (
      this.getChildContext()
        .app.getLocalStorageService()
        .isSet("search_persistent_state")
    ) {
      this.getChildContext()
        .app.getLocalStorageService()
        .remove("search_persistent_state");
    }

    this.loadPlatformInfo(() => {
      this.authHandler.checkAuthentication((status, wrongPlatform) => {
        // console.log("------- wrongPlatform ------> ", wrongPlatform);
        if (status === "OK") {
          this.setState(
            {
              accountData: this.authHandler.getAccountData(),
              app_ready: true,
            },
            () => {
              if (wrongPlatform) {
                // window.location.href = `http://${wrongPlatform}`;
              }
              if (
                this.authHandler.getAccountData().message &&
                this.props.location.pathname != "/static"
              ) {
                this.props.history.push("/static");
              }
            },
          );
        } else {
          console.log("ko", this.props.location.pathname);
          this.setPostLoginRedirect(this.props.location.pathname);
          setTimeout(() => {
            this.setState({ app_ready: true }, () => {
              //window.location = 'login';
            });
          }, 300);
        }
      });
    });
  }

  delay(time, string, app_context) {
    if (time == this.globalTime) {
      // && this.manualSearch == false per manual fire
      if (app_context.router.location.pathname != "/search") {
        app_context.redirectTo("/search");
      }
      this.setState({ searchSpin: false });
      app_context
        .getActionsShelfService()
        .do("searchActions", "updateQuery", string);
    }
  }

  // getUser(app_context) {
  //   let usr = "";
  // setInterval(() => {
  //   usr = app_context.authHandler.getAccountData().user;
  // }, 60000);
  //   return usr;
  // }

  onRender(body) {
    return this.state.app_ready ? (
      <div>
        {!this.state._alert_modal_opened ? body : null}
        <ReactOModal
          key="1"
          modalId="alertModal"
          size="md"
          onControllerReady={(modal_context) => {
            this._alert_modal = modal_context;
          }}
          onModalMounted={(data) => {
            this.setState({
              _alert_modal_opened:
                !data.type || data.type == "alert" ? true : false,
            });
          }}
          onModalUnmounted={(data) => {
            this.setState({
              _alert_modal_opened: false,
            });
          }}
          header={(data) => {
            return (
              <div>
                {!data.type || data.type == "alert" ? (
                  <span className="icon-warning text-danger title-2 mr-3 align-middle" />
                ) : null}
                {(data.title == "PROBE_NOT_FOUND"
                  ? "Data not found"
                  : data.title == "MEASURE_NOT_FOUND"
                    ? "Data not found"
                    : data.title == "BSSID_NOT_FOUND"
                      ? "Data not found"
                      : data.title || "") || ""}
              </div>
            );
          }}
          body={(data) => {
            return data.message == "PROBE_NOT_FOUND"
              ? "Probe data not available"
              : data.message == "MEASURE_NOT_FOUND"
                ? "Measure data not available"
                : data.message == "BSSID_NOT_FOUND"
                  ? "Bssid data not available"
                  : data.message || "";
          }}
          actions={[
            {
              text: "Ok",
              color: "primary",
              action: (data) => {
                this._alert_modal.close();
                if (data.cb) {
                  data.cb();
                }
              },
            },
          ]}
        />
      </div>
    ) : null;
  }
}

const mapStateToProps = (state) => ({
  ...state,
});

const mapDispatchToProps = {
  increaseCounter,
  decreaseCounter,
};

export default withRouter(
  contextProvider(
    Responsive(connect(mapStateToProps, mapDispatchToProps)(App)),
    {
      define: null,
    },
  ),
);
